/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PaymentApiConfiguration } from '../payment-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PamMerchantNotificationRequestDtoDto } from '../models/pam-merchant-notification-request-dto-dto';
import { PamMerchantNotificationResponseDtoDto } from '../models/pam-merchant-notification-response-dto-dto';


/**
 * the PmaCommandRecieveMerchantNotification API
 */
@Injectable({
  providedIn: 'root',
})
export class PmaCommandRecieveMerchantNotificationService extends BaseService {
  constructor(
    config: PaymentApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createMerchantPaymentNotification
   */
  static readonly CreateMerchantPaymentNotificationPath = '/payment/merchant/notification';

  /**
   * Create merchant payment notification
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMerchantPaymentNotification()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMerchantPaymentNotification$Response(params: {
    body: PamMerchantNotificationRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PamMerchantNotificationResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, PmaCommandRecieveMerchantNotificationService.CreateMerchantPaymentNotificationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PamMerchantNotificationResponseDtoDto>;
      })
    );
  }

  /**
   * Create merchant payment notification
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMerchantPaymentNotification$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMerchantPaymentNotification(params: {
    body: PamMerchantNotificationRequestDtoDto
  },
  context?: HttpContext

): Observable<PamMerchantNotificationResponseDtoDto> {

    return this.createMerchantPaymentNotification$Response(params,context).pipe(
      map((r: StrictHttpResponse<PamMerchantNotificationResponseDtoDto>) => r.body as PamMerchantNotificationResponseDtoDto)
    );
  }

}
